<template>
  <div class="editor">
    <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 300px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            @onChange="onChange"
            mode="simple"
            @onCreated="onCreated"
            @customPaste="customPaste"
        />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import oss from '@/api/base/api-upload'

export default {
  name: 'editor',
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number],
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
      },
      mode: 'default', // or 'simple'
      first: true
    }
  },
  computed: {
    editorConfig() {
      return {
        placeholder: this.placeholder,
        MENU_CONF: {
          // 自定义上传图片
          uploadImage: {
            customUpload: this.update
          },
          uploadVideo: {
            customUpload: this.update
          }
        },
        maxLength: this.maxlength
      }
    }
  },
  watch: {
    value (nv) {
      setTimeout(() => {
        this.html = nv
      }, 0)
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    async update(file, insertFn) {
      this.loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      oss(file, 0, 'public/activity').then(({ url }) => {
        this.loading.close()
        insertFn(url)
      }).catch(() => {
        this.$Message.warning('获取链接失败')
        this.loading.close()
      })
    },
    onChange(editor) {
      if (this.first) {
        this.first = false
        return
      }
      this.$emit('input', this.html)
    },
    customPaste(editor, event) {
      event.preventDefault()
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    setTimeout(() => {
      this.html = this.value
    }, 0)
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.editor ::v-deep .w-e-select-list {
  z-index: 9999999 !important;
}
.editor ::v-deep .w-e-drop-panel {
  z-index: 9999999 !important;
}
</style>
